import { appLineChartUp01Icon } from './line-chart-up-01';
import { appPieChart03Icon } from './pie-chart-03';
export const chartsIcons = [appLineChartUp01Icon, appPieChart03Icon];
